import { Component, ChangeDetectionStrategy, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Transaction {
  id: number;
  merchant: string;
  category: string;
  date: Date;
  amount: number;
  type: 'income' | 'expense';
  icon: string;
  status: 'Completed' | 'Pending';
}

@Component({
  selector: 'app-transactions-list',
  templateUrl: './transactions-list.component.html',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionsListComponent {
  transactions = signal<Transaction[]>([
    { id: 1, merchant: 'Apple Store', category: 'Shopping', date: new Date(), amount: 1299.99, type: 'expense', icon: 'shopping-cart', status: 'Completed' },
    { id: 2, merchant: 'Starbucks', category: 'Food', date: new Date(), amount: 8.50, type: 'expense', icon: 'coffee', status: 'Pending' },
    { id: 3, merchant: 'Monthly Salary', category: 'Income', date: new Date(Date.now() - 86400000), amount: 4500.00, type: 'income', icon: 'briefcase', status: 'Completed' },
    { id: 4, merchant: 'Netflix Subscription', category: 'Entertainment', date: new Date(Date.now() - 86400000 * 2), amount: 15.99, type: 'expense', icon: 'film', status: 'Completed' },
    { id: 5, merchant: 'Amazon', category: 'Shopping', date: new Date(Date.now() - 86400000 * 3), amount: 75.40, type: 'expense', icon: 'shopping-cart', status: 'Completed' },
  ]);
  
  filter = signal<'all' | 'income' | 'expense'>('all');

  filteredTransactions = computed(() => {
    const all = this.transactions();
    const f = this.filter();
    if (f === 'all') {
      return this.groupTransactionsByDate(all);
    }
    const filtered = all.filter(t => t.type === f);
    return this.groupTransactionsByDate(filtered);
  });
  
  private groupTransactionsByDate(transactions: Transaction[]): { title: string, transactions: Transaction[] }[] {
    const groups: {[key: string]: Transaction[]} = {};
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    transactions.forEach(t => {
      const tDate = new Date(t.date);
      tDate.setHours(0, 0, 0, 0);

      let key = '';
      if (tDate.getTime() === today.getTime()) {
        key = 'Today';
      } else if (tDate.getTime() === yesterday.getTime()) {
        key = 'Yesterday';
      } else {
        key = tDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
      }

      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(t);
    });

    return Object.keys(groups).map(key => ({
      title: key,
      transactions: groups[key]
    }));
  }
}
